import { useContext } from 'react'

import { ConfirmContext, ConfirmProps } from 'providers/ConfirmProvider'

export const useConfirm = (): ((props: ConfirmProps) => Promise<boolean>) => useContext(ConfirmContext)
